import { format } from 'date-fns';
import range from 'lodash/range';
import { offset } from '@floating-ui/react';

export const MONTHS = {
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
};

const START_YEAR = 1990;
const END_YEAR = new Date().getFullYear() + 20;
const YEARS_LIST: number[] = range(START_YEAR, END_YEAR);
const MONTHS_LIST = Object.values(MONTHS);
const NEGATIVE_TOP_OFFSET = -18;

export const FLOATING_MODIFIER = [offset(NEGATIVE_TOP_OFFSET)];

export const getMonthIndex = (month: string) => {
  return MONTHS_LIST.findIndex((value) => value === month);
};

export const getCurrentMonth = (date: Date) => {
  return format(date, 'LLLL');
};

export const getCurrentYear = (currentDate: Date | number) => {
  return String(new Date(currentDate).getFullYear());
};

export const MONTHS_OPTIONS = MONTHS_LIST.map((month) => ({ value: month, label: month }));
export const YEARS_OPTIONS = YEARS_LIST.map((year: number) => {
  const stringifiedYear = year.toString();

  return { value: stringifiedYear, label: stringifiedYear };
});

export const getInitialMonthOption = (date: Date) => {
  const month = getCurrentMonth(date);

  return { value: month, label: month };
};

export const getInitialYearOption = (date: Date) => {
  const year = getCurrentYear(date);

  return { value: year, label: year };
};
